import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {

    let swipers = [];

    // Function to destroy existing Swipers
    function destroySwipers() {
        swipers.forEach(swiper => swiper.destroy(true, true)); // Destroy existing Swipers
        swipers = []; // Clear the array of Swiper instances
    }

    // Function to initialize Swipers
    function initializeSwipers() {
        console.log("Initializing Swipers...");
        const componentOfferCardsSwipers = document.querySelectorAll('.component-offer-cards__swiper'); // BEM class for swiper container
        
        componentOfferCardsSwipers.forEach((componentOfferCardsSwiper) => {
            console.log("Initializing Swiper for:", componentOfferCardsSwiper);
            const swiper = new Swiper(componentOfferCardsSwiper, {
                loop: true,
                slidesPerView: 1.4,
                spaceBetween: 40,
                pagination: {
                    el: componentOfferCardsSwiper.querySelector('.swiper-pagination'),
                    type: 'fraction', // This will display '1/2', '2/2', etc.
                    clickable: true,
                },
                navigation: {
                    nextEl: componentOfferCardsSwiper.querySelector('.swiper-button-next'), // BEM class for next button
                    prevEl: componentOfferCardsSwiper.querySelector('.swiper-button-prev'), // BEM class for prev button
                },
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                        loopAddBlankSlides: true,
                    },
                },
            });

            // Store the Swiper instance in the swipers array for future destruction
            swipers.push(swiper);
        });
    }

    // Initial Swiper setup
    console.log("Initial Swiper setup...");
    initializeSwipers();

    const filter        = document.getElementById('page-offers__filters__location');
    const specialFilter = document.getElementById('page-offers__filters__special');
    const container     = document.querySelector('.page-offers__output');

    if (!container || !filter  || !specialFilter) return;

    filter.addEventListener('change', fetchAndRender);
    specialFilter.addEventListener('change', fetchAndRender);

    async function fetchAndRender() {
        const locationId   = filter.value;
        const specialId    = specialFilter.value;
      
        container.classList.add('opacity-0', 'transition-opacity', 'duration-300');
      
        // ———  A) If we have a location, grab its slug + its direct children ———
        let locationSlug = '';
        let locationIds  = [];
      
        if (locationId) {
          // 1. Fetch the term itself (to get its slug)
          const termRes = await fetch(`/wp-json/wp/v2/location/${locationId}`);
          const term    = await termRes.json();
          locationSlug  = term.slug;
      
          // 2. Fetch any children of that term
          const kidsRes = await fetch(
            `/wp-json/wp/v2/location?parent=${locationId}&per_page=100`
          );
          const children = await kidsRes.json();
      
          // 3. Combine parent + any child IDs
          locationIds = [
            Number(locationId),
            ...children.map(c => c.id)
          ];
        }
      
        // ———  B) Now build your API params (IDs) ———
        const apiParams = new URLSearchParams();
        apiParams.set('per_page', '100');
        apiParams.set('orderby', 'menu_order');
        apiParams.set('order', 'asc');
        if (locationIds.length)           apiParams.set('location',     locationIds.join(','));
        if (specialId)                    apiParams.set('special-for',  specialId);
        apiParams.set('_embed', '');      // so your featured media and wp:term embeds come back
      
        // ———  C) Build your pretty URL params (slugs) ———
        const urlParams = new URLSearchParams();
        urlParams.set('per_page', '100');
        if (locationSlug)   urlParams.set('location',     locationSlug);
        if (specialId) {
          // You’ll want the special-for term’s slug the same way:
          const sfRes      = await fetch(`/wp-json/wp/v2/special-for/${specialId}`);
          const sfTerm     = await sfRes.json();
          urlParams.set('special-for', sfTerm.slug);
        }
      
        // 4) Push the pretty URL
        const prettyUrl = `${window.location.pathname}?${urlParams.toString()}`;
        window.history.replaceState({}, '', prettyUrl);
      
        // 5) Finally fetch & render
        try {
          const res   = await fetch(`/wp-json/wp/v2/experience?${apiParams.toString()}`);
          const posts = await res.json();
    
          if (!posts.length) {
            container.innerHTML = '<p>No posts found for this selection.</p>';
            return;
          }

            // Group posts by their first category
            const grouped = {};
            const categoryIds = new Set();

            posts.forEach(post => {
                const catIds = post.categories;
                if (!catIds || !catIds.length) return;

                catIds.forEach(catId => {
                    categoryIds.add(catId);
                    if (!grouped[catId]) {
                        grouped[catId] = {
                            name: '',
                            description: '',
                            posts: [],
                        };
                    }

                    // Avoid adding duplicates in case the post was already added under this category
                    if (!grouped[catId].posts.some(p => p.id === post.id)) {
                        grouped[catId].posts.push(post);
                    }
                });
            });

            // Fetch category data for these IDs
            console.log("Fetching category data for IDs:", [...categoryIds].join(','));
            const catRes = await fetch(`/wp-json/wp/v2/categories?include=${[...categoryIds].join(',')}`);
            let cats = await catRes.json();
            console.log("Fetched categories:", cats);

            // Define custom order: lower index = higher priority
            const customCategoryOrder = [7, 15, 17, 16]; // Add your category IDs in the desired order

            cats.sort((a, b) => {
                const aIndex = customCategoryOrder.indexOf(a.id);
                const bIndex = customCategoryOrder.indexOf(b.id);

                // If both have a custom order, sort by that
                if (aIndex !== -1 && bIndex !== -1) {
                    return aIndex - bIndex;
                }

                // If only one has a custom order, that one comes first
                if (aIndex !== -1) return -1;
                if (bIndex !== -1) return 1;

                // Otherwise, maintain default order (or sort alphabetically if you want)
                return 0;
            });

            // Add category name/description to each group
            cats.forEach(cat => {
                if (grouped[cat.id]) {
                    grouped[cat.id].name = cat.name;
                    grouped[cat.id].description = cat.description;
                }
            });

            // Sort posts in each group by menu_order (ascending)
            Object.values(grouped).forEach(group => {
                group.posts.sort((a, b) => (a.menu_order || 0) - (b.menu_order || 0));
            });

            // Build the HTML for the new content
            container.innerHTML = '';

            cats.forEach(cat => {
                const group = grouped[cat.id];
                if (!group || !group.posts.length) return;

                const section = document.createElement('section');
                section.classList.add('my-[50px]');
                section.innerHTML = `
                    <div class="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-2 wp-block-columns-is-layout-flex">
                        <div class="is-layout-flow wp-block-column-is-layout-flow md:basis-[25%]">
                            <h2 class="wp-block-heading has-text-color has-link-color">${group.name}</h2>
                        </div>
                        <div class="is-layout-flow wp-block-column-is-layout-flow md:basis-[66.66%]">
                            <p class="has-text-color has-link-color has-large-font-size">
                                ${group.description}
                            </p>
                        </div>
                    </div>
                    <div class="component-offer-cards">
                        <div class="component-offer-cards__inner">
                            <div class="component-offer-cards__content">
                                <div class="component-offer-cards__swiper swiper overflow-visible md:overflow-hidden">
                                    <div class="swiper-wrapper">
                                    </div>
                                    <div class="[&:has(.swiper-button-lock)]:hidden flex items-center justify-center gap-[24px] mt-[28px]">
                                        <div class="swiper-button-prev">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                                <g clip-path="url(#clip0_1465_68345)">
                                                    <mask id="mask0_1465_68345" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
                                                    <rect x="0.5" width="24" height="24" fill="#C4C4C4"/>
                                                    </mask>
                                                    <g mask="url(#mask0_1465_68345)">
                                                    <path d="M3.29785 11.5H20.2979L21.2979 12.5L20.2979 13.5L3.29785 13.4988V11.5Z" fill="#585636"/>
                                                    <path d="M20.2979 11.5L11.7979 3L10.3836 4.41421L15.4547 9.48528C16.7353 10.7659 18.4868 11.5 20.2979 11.5Z" fill="#585636"/>
                                                    <path d="M20.2979 13.5L11.7979 22L10.3836 20.5858L15.4547 15.5147C16.7353 14.2341 18.4868 13.5 20.2979 13.5Z" fill="#585636"/>
                                                    </g>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1465_68345">
                                                    <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>

                                        <div class="swiper-pagination font-bwBeto md:text-[24px] md:leading-[30px]"></div>

                                        <div class="swiper-button-next">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                                <g clip-path="url(#clip0_1465_68345)">
                                                    <mask id="mask0_1465_68345" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
                                                    <rect x="0.5" width="24" height="24" fill="#C4C4C4"/>
                                                    </mask>
                                                    <g mask="url(#mask0_1465_68345)">
                                                    <path d="M3.29785 11.5H20.2979L21.2979 12.5L20.2979 13.5L3.29785 13.4988V11.5Z" fill="#585636"/>
                                                    <path d="M20.2979 11.5L11.7979 3L10.3836 4.41421L15.4547 9.48528C16.7353 10.7659 18.4868 11.5 20.2979 11.5Z" fill="#585636"/>
                                                    <path d="M20.2979 13.5L11.7979 22L10.3836 20.5858L15.4547 15.5147C16.7353 14.2341 18.4868 13.5 20.2979 13.5Z" fill="#585636"/>
                                                    </g>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1465_68345">
                                                    <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                const cardsContainer = section.querySelector('.swiper-wrapper');

                // Add each post as a new card
                group.posts.forEach(post => {
                    const image = post._embedded?.['wp:featuredmedia']?.[0]?.source_url ?? 'http://localhost:8888/wp-content/uploads/2025/04/build-img-placeholder.webp';

                    const card = document.createElement('div');
                    card.classList.add('component-offer-cards__card', 'swiper-slide', 'flex', 'flex-col', 'h-auto');

                    const { link_override: linkOverride } = post.acf || {};

                    const link       = linkOverride?.url    || post.link;
                    const linkTitle  = linkOverride?.title  || 'Learn More';
                    const linkTarget = linkOverride?.target || '_self';

                    card.innerHTML = `
                        <a class="group flex flex-col h-full" href="${link}" title="${linkTitle}" target="${linkTarget}">
                            <picture class="block border border-oak w-full h-auto mb-[16px] aspect-[1/1] md:aspect-[4/5]">
                                <source media="(max-width: 767px)" srcset="${image}">
                                <source media="(min-width: 768px)" srcset="${image}">
                                <img class="block w-full h-full object-cover aspect-[1/1] md:aspect-[4/5]" src="${image}" alt="${post.title.rendered}" loading="lazy" decoding="async" aria-hidden="true">
                            </picture>

                            <span class="block mb-[8px]">
                                <h4>${post.title.rendered}</h4>
                            </span>

                            <span class="block mb-[16px]">
                                <p>${post.excerpt.rendered.replace(/<[^>]+>/g, '').slice(0, 100)}</p>
                            </span>

                            <span class="text-moss underline decoration-[2px] underline-offset-[3px] group-hover:text-moss-80 font-bwAleta text-[16px] font-semibold mt-auto md:decoration-transparent group-hover:decoration-moss-80 group-hover:underline transition-all">
                                ${linkTitle}
                            </span>
                        </a>
                    `;



                    cardsContainer.appendChild(card);
                });

                container.appendChild(section);
            });

            // Destroy old Swipers and reinitialize new ones
            destroySwipers();
            initializeSwipers();

        } catch (err) {
            console.error('Error fetching life hacks:', err);
            container.innerHTML = '<p>Error loading life hacks. Please try again.</p>';
        } finally {
            // Fade in the container once the content is loaded
            setTimeout(() => {
                console.log("Fading in container...");
                container.classList.remove('opacity-0');
            }, 50);
        }
    };
});